import { buffers, channel } from 'redux-saga'
import { put, take } from 'redux-saga/effects'

import { subscribe } from '../realtime/realtime'

function* subscribeToRealtimeUpdates(actionName) {
  const realtimeChannel = channel(buffers.expanding())
  const subscription = subscribe('public', '/all_json', (realtimeData) =>
    realtimeChannel.put(realtimeData)
  )

  try {
    yield subscription

    while (true) {
      const realtimeData = yield take(realtimeChannel)
      yield put({ type: actionName, realtimeData })
    }
  } finally {
    realtimeChannel.close()
    void subscription.then(
      (unsubscribe) => unsubscribe(),
      () => undefined
    )
  }
}

export { subscribeToRealtimeUpdates }
